/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { AuthGuard } from '../auth.guard';
import { LoginComponent } from '../login/login.component';
import { NewUserComponent } from '../new-user/new-user.component';
import { LogoutComponent } from '../logout/logout.component';
import { DemoComponent } from '../demo/demo.component';
import { PreTrialComponent } from '../pre-trial/pre-trial.component';
import { PasswordResetComponent } from '../password-reset/password-reset.component';

export const authRouterConfig = [
  {
    path: 'demo',
    component: DemoComponent,
    canActivate: [AuthGuard],
    data: { role: 'public', title: 'Request demo', uiTitle: 'Request demo' }
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AuthGuard],
    data: { role: 'public', title: 'Log in', uiTitle: 'Log In' }
  },
  {
    path: 'new-user/:token',
    component: NewUserComponent,
    canActivate: [AuthGuard],
    data: { role: 'public', title: 'Welcome to Drift Email', uiTitle: 'Welcome to Drift Email' }
  },
  {
    path: 'logout',
    component: LogoutComponent,
    canActivate: [AuthGuard],
    data: { role: 'public', title: 'Log out', uiTitle: 'Log out' }
  },
  {
    path: 'pre',
    component: PreTrialComponent,
    canActivate: [AuthGuard],
    data: { role: 'public', title: 'Pre-trial', uiTitle: 'Pre-trial' }
  },
  {
    path: 'pwreset/:token',
    component: PasswordResetComponent,
    canActivate: [AuthGuard],
    data: { role: 'public', title: 'Reset password', uiTitle: 'Reset password' }
  }
];



// WEBPACK FOOTER //
// ./client/app/routes/auth.routes.ts